/**
 * DataSpecialistStageNav — the DS Case Workspace nav chrome — a Stage Strip over the DS
 * stages (Extraction → Transactions → Validation → Handoff); rendered ONLY for
 * role="data_specialist". No Case Profile Bar (posture/claim-type isn't the DS's concern).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StageStrip, stagesForRole, type StageStripItem } from './stage-strip';
import { CaseMatcherLink, CaseReconcileLink } from '../matcher/CaseMatcherLink';

export interface DataSpecialistStageNavProps {
  /** Base path for stage navigation (e.g. /data-specialist/case/:caseId) */
  basePath: string;
  /** The currently viewed stage id */
  activeStageId: string;
  className?: string;
}

export function DataSpecialistStageNav({ basePath, activeStageId, className }: DataSpecialistStageNavProps) {
  const navigate = useNavigate();

  const stages: StageStripItem[] = stagesForRole('data_specialist').map((s) => ({
    id: s.id,
    label: s.label,
  }));
  // caseId is the last path segment of basePath (/data-specialist/case/:caseId) and equals the report_id.
  const reportId = basePath.split('/').filter(Boolean).pop() || '';

  return (
    <div className={className}>
      <div className="flex items-center justify-between gap-4 pr-4">
        <div className="min-w-0 flex-1">
          <StageStrip
            stages={stages}
            activeStageId={activeStageId}
            onNavigate={(id) => navigate(`${basePath}/${id}`)}
          />
        </div>
        <CaseMatcherLink reportId={reportId} />
        <CaseReconcileLink reportId={reportId} />
      </div>
    </div>
  );
}

export default DataSpecialistStageNav;
